<template>
  <div
    class="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 bg-white px-8 text-center font-mainFont"
    :class="variant === 'full' ? 'h-screen w-full' : 'w-full py-9'"
    :role="reconnected ? 'status' : 'alert'"
  >
    <AppIcon
      v-if="reconnected"
      name="i-heroicons-check-circle-20-solid"
      class="size-8 text-success-500"
      aria-hidden="true"
    />
    <h3 class="text-lg font-medium text-neutral-600">{{ title }}</h3>
    <p v-if="description" class="max-w-md text-sm text-neutral-600">
      {{ description }}
    </p>
    <span
      v-if="eta"
      data-testid="maintenance-board-eta"
      class="inline-flex items-center gap-1.5 text-xs text-neutral-500"
    >
      <AppIcon
        name="i-heroicons-clock-20-solid"
        class="size-3.5"
        aria-hidden="true"
      />
      {{ eta }}
    </span>
    <UButton
      v-if="retryLabel"
      color="primary"
      variant="solid"
      size="lg"
      @click="emit('retry')"
    >
      {{ retryLabel }}
    </UButton>
    <span
      v-if="variant === 'full' && autoCheckHint"
      class="text-xs text-neutral-500"
    >
      {{ autoCheckHint }}
    </span>
  </div>
</template>

<script setup>
import AppIcon from '../../AppIcon.vue'

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  eta: {
    type: String,
    default: '',
  },
  retryLabel: {
    type: String,
    default: '',
  },
  autoCheckHint: {
    type: String,
    default: '',
  },
  reconnected: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: 'full',
    validator: (value) => ['full', 'scoped'].includes(value),
  },
})

const emit = defineEmits(['retry'])
</script>
